export default {
    paymentsList: {
        actions: 'Actions',
        allTab: 'All',
        amount: 'Amount',
        bulkAction: 'Bulk Action',
        contact: 'Contact',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete payment',
            message: 'Are you sure you want to delete this payment?',
        },
        errors: {
            deleting: 'An error occured. Payment could not be deleted. | An error occured. Payments could not not be deleted.',
        },
        noPayments: 'No payments.',
        number: 'Invoice number',
        pageTitle: 'Payments',
        received: 'Received',
        receivedTab: 'Received',
        sendPaymentLink: 'Send payment link',
        sentOn: 'Sent On',
        status: 'Status',
        statuses: {
            sent: 'Sent',
            seen: 'Seen',
            paid: 'Paid',
            expired: 'Expired',
            notSent: 'Not sent',
        },
        successes: {
            deleted: 'Payment deleted successfully. | Payments deleted successfully.',
        },
        tooltips: {
            deletePaidNotAllowed: 'A payment that has been received cannot be deleted.',
            updateSeenNotAllowed: 'A payment link that has been seen cannot be modified.',
        },
        pendingTab: 'Pending',
        wouldYouLikeToAddOne: 'Would you like to add one?',
    },
    paymentModal: {
        amount: 'Amount',
        contact: 'Contact',
        notifications: {
            error: {
                send: 'An error occured while sending the payment link.',
                create: 'An error occured while creating the payment.',
                update: 'An error occured while updating the payment.',
                uploadingFile: 'An error occured while uploading the file.',
            },
            success: {
                create: 'Payment created successfully.',
                update: 'Payment updated successfully.',
            },
        },
        paymentDetails: 'Payment details',
        promptSendPaymentLinkModal: {
            header: 'Send payment link',
            message: 'Would you like to send the payment link to the contact now? A new window will open to let you write a custom message.',
        },
        message: 'Message',
        invoiceNumber: 'Invoice number',
        title: {
            create: 'Create payment',
            edit: 'Edit payment',
        },
    },
    sendPaymentLinkModal: {
        title: 'Send payment link',
        notifications: {
            error: {
                send: 'An error occured while sending the payment link.',
            },
            success: {
                send: 'Payment link sent successfully.',
            },
        },
    },
};
